import React from 'react'
import Gallery1 from '../../assets/Images/all-gallary-1.png';
import Gallery2 from '../../assets/Images/all-gallary-2.png';
import Gallery3 from '../../assets/Images/all-gallary-3.png';
import Gallery4 from '../../assets/Images/all-gallary-4.png';
import Gallery5 from '../../assets/Images/all-gallary-5.png';
import Gallery6 from '../../assets/Images/all-gallary-6.png';
import Gallery7 from '../../assets/Images/all-gallary-7.png';
import Gallery8 from '../../assets/Images/all-gallary-8.png';
import Design1 from '../../assets/Images/Design/1.jpg';
import Design2 from '../../assets/Images/Design/2.jpg';
import Design3 from '../../assets/Images/Design/4.jpg';
import Design4 from '../../assets/Images/Design/5.jpg';
import Design5 from '../../assets/Images/Design/6.jpg';
import Design6 from '../../assets/Images/Design/7.jpg';

import Dev1 from '../../assets/Images/Web Development/1.jpg';
import Dev2 from '../../assets/Images/Web Development/2.jpg';
import Dev3 from '../../assets/Images/Web Development/3.jpg';
import Dev4 from '../../assets/Images/Web Development/4.jpg';
import Dev5 from '../../assets/Images/Web Development/5.jpg';
import Dev6 from '../../assets/Images/Web Development/6.jpg';

import UI1 from '../../assets/Images/UI UX/1.jpg';
import UI2 from '../../assets/Images/UI UX/2.jpg';

import Market1 from '../../assets/Images/Marketing/1.jpg';
import Market2 from '../../assets/Images/Marketing/2.jpg';
import Market3 from '../../assets/Images/Marketing/3.jpg';
import Market4 from '../../assets/Images/Marketing/4.jpg';

import SEO1 from '../../assets/Images/SEO/1.jpg';
import SEO2 from '../../assets/Images/SEO/2.jpg';
import SEO3 from '../../assets/Images/SEO/3.jpg';
import SEO4 from '../../assets/Images/SEO/4.jpg';
import SEO5 from '../../assets/Images/SEO/5.jpg';



function Gallery() {
    return (
        <section className='gallery'>
            <div className="gall-bg"></div>
            <span></span>
            <div class="container gall-main"> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1300" */}
                <ul class="nav nav-pills mb-4 d-flex flex-wrap gap-2" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-photo-tab" data-bs-toggle="pill" data-bs-target="#pills-photo" type="button" role="tab" aria-controls="pills-photo" aria-selected="true">All</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-interior-tab" data-bs-toggle="pill" data-bs-target="#pills-interior" type="button" role="tab" aria-controls="pills-interior" aria-selected="false">DESIGN</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-food-tab" data-bs-toggle="pill" data-bs-target="#pills-food" type="button" role="tab" aria-controls="pills-food" aria-selected="false">DEVELOPMENT</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-events-tab" data-bs-toggle="pill" data-bs-target="#pills-events" type="button" role="tab" aria-controls="pills-events" aria-selected="false">BRANDING</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-Guest-tab" data-bs-toggle="pill" data-bs-target="#pills-Guest" type="button" role="tab" aria-controls="pills-Guest" aria-selected="false">UI/UX</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="marketing-tab" data-bs-toggle="pill" data-bs-target="#marketing" type="button" role="tab" aria-controls="pills-marketing" aria-selected="false">MARKETING</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="seo-tab" data-bs-toggle="pill" data-bs-target="#seo" type="button" role="tab" aria-controls="pills-seo" aria-selected="false">SEO</button>
                    </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-photo" role="tabpanel" aria-labelledby="pills-photo-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery1} alt="gallery1.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery2} alt="gallery2.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery3} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery4} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery5} alt="gallery5.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery6} style={{ height: '200px' }} alt="gallery6.img" />
                                        </figure>
                                        <figure>
                                            <img src={Gallery7} style={{ height: '200px' }} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery8} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-interior" role="tabpanel" aria-labelledby="pills-interior-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Design1} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Design2} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div className="col-md-4 p-0">
                                        <figure>
                                            <img src={Design3} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Design4} alt="gallery1.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Design5} alt="gallery2.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Design6} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-food" role="tabpanel" aria-labelledby="pills-food-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Dev1} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Dev2} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Dev6} alt="gallery5.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Dev4} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div className="col-md-4 p-0">
                                        <figure>
                                            <img src={Dev5} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Dev3} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-events" role="tabpanel" aria-labelledby="pills-events-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery8} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery6} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-Guest" role="tabpanel" aria-labelledby="pills-Guest-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={UI1} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={UI2} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="marketing" role="tabpanel" aria-labelledby="marketing-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Market1} alt="gallery1.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Market2} alt="gallery2.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Market4} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Market3} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="seo" role="tabpanel" aria-labelledby="seo-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={SEO1} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={SEO2} alt="gallery5.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={SEO3} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={SEO4} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={SEO5} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="gallery-hr d-flex align-items-center justify-content-end gap-3 mt-4">
                    <h6>Creative Solution</h6>
                    <hr />
                </div>
            </div>
        </section>
    )
}

export default Gallery
